const PropTypes = require('prop-types');
const React = require('react');
const classNames = require('classnames');
const ReactCSSTransitionGroup = require('react-addons-css-transition-group');
const Wysihtml5 = require('components/shared/wysihtml5');

const inputLimit = 100;
const autofilledFields = ['make', 'model', 'finish', 'title'];

class LocalizedContent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: props.id || null,
      make: props.make || '',
      model: props.model || '',
      finish: props.finish || '',
      title: props.title || '',
      description: props.description || '',
      enabled: props.enabled || false,
      showCharacterCounter: false,
    };
  }

  nameForInput(fieldName) {
    return `${this.props.nameForInput}[${fieldName}]`;
  }

  titleCountRemaining() {
    return inputLimit - this.state.title.length;
  }

  get persisted() {
    return this.state.id;
  }

  get isEmpty() {
    return this.state.make === '' &&
      this.state.model === '' &&
      this.state.finish === '' &&
      this.state.title === '' &&
      this.state.description === '';
  }

  autofillFields() {
    if (!this.isEmpty) { return; } // don't overwrite any fields

    const stateChange = {};

    autofilledFields.forEach((field) => {
      stateChange[field] = this.getListingVal(field);
    });

    this.setState(stateChange);
  }

  getListingVal(field) {
    return $(`input[name="product[${field}]"`).val();
  }

  handleToggle(enabled) {
    this.setState({ enabled });
    if (enabled) { this.autofillFields(); }
  }

  renderCharacterCounterContent() {
    if (!this.state.showCharacterCounter) { return null; }
    return (
      <div key={this.state.locale}>
        {I18n.t('listingForm.localizedContent.charactersLeft',
          { count: this.titleCountRemaining() })
        }
      </div>
    );
  }

  renderHeaderContent() {
    return (
      <label className="boxed-list__toggle">
        <input
          type="checkbox"
          className="inline-block mr-half"
          name={this.nameForInput('enabled')}
          value="enabled"
          checked={this.state.enabled}
          onChange={(event) => this.handleToggle(event.target.checked)}
        />
        <h4 className="heading-4 inline-block cursor-pointer vertical-top">
          {this.props.localeName}
        </h4>
      </label>
    );
  }

  renderIdInput() {
    if (!this.state.id) { return null; }
    return (
      <input
        type="hidden"
        name={this.nameForInput('id')}
        defaultValue={this.state.id}
      />
    );
  }

  renderDisabledContent() {
    if (!this.persisted) { return null; }
    return this.renderMarkForDeletionContent();
  }

  renderMarkForDeletionContent() {
    return (
      <div>
        {this.renderIdInput()}
        <input
          type="hidden"
          name={this.nameForInput('_destroy')}
          defaultValue="true"
        />
      </div>
    );
  }

  renderFormFields() {
    return (
      <div className="boxed-list__body">
        {this.renderIdInput()}
        <input
          type="hidden"
          name={this.nameForInput('locale')}
          defaultValue={this.props.locale}
        />
        <div className="g-container">
          <div className="g-col-4 g-col-mobile-12">
            <label>
              {I18n.t('listingForm.localizedContent.brand')}
            </label>
            <input
              type="text"
              className="wide required"
              maxLength={inputLimit}
              name={this.nameForInput('make')}
              value={this.state.make}
              onChange={(event) => this.setState({ make: event.target.value })}
            />
          </div>
          <div className="g-col-4 g-col-mobile-12">
            <label>
              {I18n.t('listingForm.localizedContent.model')}
            </label>
            <input
              type="text"
              className="wide required"
              maxLength={inputLimit}
              name={this.nameForInput('model')}
              value={this.state.model}
              onChange={(event) => this.setState({ model: event.target.value })}
            />
          </div>
          <div className="g-col-4 g-col-mobile-12">
            <label>
              {I18n.t('listingForm.localizedContent.finish')}
            </label>
            <input
              type="text"
              className="wide"
              maxLength={inputLimit}
              name={this.nameForInput('finish')}
              value={this.state.finish}
              onChange={(event) => this.setState({ finish: event.target.value })}
            />
          </div>
        </div>
        <label className="clearfix">
          {I18n.t('listingForm.localizedContent.title')}
          <span className="hint pull-right">
            <ReactCSSTransitionGroup
              transitionName="title-character-count"
              transitionEnterTimeout={300}
              transitionLeaveTimeout={300}
            >
              {this.renderCharacterCounterContent()}
            </ReactCSSTransitionGroup>
          </span>
        </label>
        <input
          type="text"
          className="wide required"
          maxLength={inputLimit}
          name={this.nameForInput('title')}
          value={this.state.title}
          onChange={(event) => this.setState({ title: event.target.value })}
          onFocus={() => this.setState({ showCharacterCounter: true })}
          onBlur={() => this.setState({ showCharacterCounter: false })}
        />
        <label className="text optional control-label">
          {I18n.t('listingForm.localizedContent.description')}
        </label>
        <Wysihtml5
          value={this.state.description}
          onChange={(description) => { this.setState({ description }); }}
          id={`description-${this.props.locale}`}
          name={this.nameForInput('description')}
        />
      </div>
    );
  }

  renderMainContent() {
    if (!this.state.enabled) { return this.renderDisabledContent(); }
    return this.renderFormFields();
  }

  render() {
    return (
      <div
        className={classNames(
          'boxed-list__item boxed-list__item--checkbox-toggleable',
          { 'boxed-list__item--selected': this.state.enabled }
        )}
      >
        {this.renderHeaderContent()}
        {this.renderMainContent()}
      </div>
    );
  }
}

LocalizedContent.propTypes = {
  nameForInput: PropTypes.string,
  id: PropTypes.number,
  locale: PropTypes.string.isRequired,
  make: PropTypes.string,
  model: PropTypes.string,
  finish: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  localeName: PropTypes.string,
  enabled: PropTypes.bool,
};

module.exports = LocalizedContent;



// WEBPACK FOOTER //
// ./javascripts/components/listing_form/localized_content.jsx